import { render, staticRenderFns } from "./inventory-form.vue?vue&type=template&id=9b406d30&scoped=true&"
import script from "./inventory-form.vue?vue&type=script&lang=js&"
export * from "./inventory-form.vue?vue&type=script&lang=js&"
import style0 from "./inventory-form.vue?vue&type=style&index=0&id=9b406d30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b406d30",
  null
  
)

export default component.exports